import { Image, View } from 'react-native'
import styled from 'styled-components/native'

import { PrimaryButton } from 'APP/Components/Buttons'
import Card from 'APP/Converse/Card'
import Typography from 'APP/Converse/Typography'

export const StyledView = styled(View)`
  flex: 1;
  background-color: ${({ theme }) => theme.colors.background};
  justify-content: center;
  align-items: center;
`

export const StyledCard = styled(Card)`
  max-width: 550px;
  width: 100%;
`

export const TextWrapper = styled.View`
  padding-horizontal: ${({ theme }) => theme.metrics.baseMargin}px;
`

export const Title = styled(Typography)`
  margin-bottom: ${({ theme }) => theme.metrics.baseMargin}px;
`

export const StyledButton = styled(PrimaryButton)`
  margin-bottom: 0;
  margin-horizontal: ${({ theme }) => theme.metrics.baseMargin / 2}px;
`

export const ImageWrapper = styled.View`
  align-items: center;
  justify-content: center;
  margin-top: ${({ theme }) => theme.metrics.baseMargin / 2}px;
  margin-bottom: ${({ theme }) => theme.metrics.baseMargin}px;
`

export const Illustration = styled(Image)`
  height: 55px;
  width: 55px;
`
